<li class="m-menu-item"
    :class="{'m--is-selected': selected,
             'm--is-disabled': isDisabled,
             'm--is-group': group,
             'm--is-open': propOpen,
             'm--is-custom-content': $slots['content'],
             'm--is-inside-group': insideGroup}"
    role="none">
    <router-link v-if="isUrl" class="m-menu-item__link"
                 :class="{'m--is-disabled': isDisabled}"
                 :to="url"
                 :aria-selected="selected ? 'page' : undefined"
                 role="menuitem"
                 @click="onClick">
        <m-icon class="m-menu-item__icon"
                v-if="iconName"
                :name="iconName"
                size="1em"
                ref="icon"></m-icon>
        <span class="m-menu-item__label">{{ label }}</span>
    </router-link>
    <span v-else
          :id="id"
          class="m-menu-item__link"
          :class="{ 'm--is-disabled': isDisabled,
                    'm--is-custom-content': $slots['content']}"
          role="button"
          :tabindex="isDisabled ? '-1' : '0'"
          :aria-selected="selected"
          :aria-controls="group ? ariaControls : undefined"
          :aria-expanded="group ? (propOpen ? 'true' : 'false') : undefined"
          @click="onClick"
          @keydown.enter="onClick"
          @keydown.space="onClick">
        <slot name="content">
            <m-icon class="m-menu-item__icon"
                    v-if="iconName"
                    :name="iconName"
                    ref="icon"
                    size="1em"></m-icon>
            <span class="m-menu-item__label">{{ label }}</span>
            <m-plus class="m-menu-item__plus"
                    skin="current-color"
                    :open="propOpen"
                    :large="selected"
                    ref="plus"
                    v-if="group"></m-plus>
        </slot>
    </span>
    <m-accordion-transition :disabled="!animReady || isDisabled"
                            ref="transition">
        <ul v-show="propOpen"
            :id="ariaControls"
            ref="group"
            class="m-menu-item__group"
            :aria-labelledby="id">
            <slot></slot>
        </ul>
    </m-accordion-transition>
</li>
